
const urlLocationService = "https://api.ipinfodb.com/v3/ip-city/?key=afd4ff3d63532c4030903c7f4d139e0f14a88b351bdc23ad37c5f69358b50fda&format=json";

export const Location = () => {
    return fetch(urlLocationService,
        {
            method: "GET"
        })
        .then(response => {
            var data = response.json();
            return data;
        });
}
